import { isNil } from "lodash-es";
import IGroupItem from "@models/IGroupItem";

export interface IItemsToProcess {
    [key: string]: {
        item_guid: string;
        item_id: number;
        qty: string;
    };
}

interface GateOpts {
    noInputPadding?: boolean;
    isHorizontal?: boolean;
    itemsToProcess: IItemsToProcess;
}

export const getGroupItemData = (
    groupItem: IGroupItem,
    opts: GateOpts
): { qtyInputClass: string; qty: string; disableQtyInput: boolean; max: number | undefined; guid: string } => {
    const guid = groupItem.guid || "";
    let qty = opts.itemsToProcess[guid]?.qty || "";
    let disableQtyInput = false;
    let qtyInputClass = "";
    let max: number | undefined;

    if (groupItem.has_inventory) {
        if ((groupItem.qty_on_hand || 0) <= 0) {
            if (isNil(groupItem.allow_backorder) || !groupItem.allow_backorder) {
                disableQtyInput = true;
            } else {
                if (groupItem.allow_backorder) {
                    qtyInputClass = "bg-warning";
                } else {
                    max = Math.max(0, groupItem.qty_on_hand || 0);
                }
            }
        }
    }

    if (!groupItem.active) {
        disableQtyInput = true;
        max = 0;
        qty = "";
    }

    if (opts.noInputPadding) {
        qtyInputClass += ` ps-0 pe-0`;
    }

    if (!opts.isHorizontal) {
        qtyInputClass += ` w-7r`;
    }

    return { qtyInputClass, qty, disableQtyInput, max, guid };
};

export const renderGroupItemInventory = (groupItem: IGroupItem) => (
    <div className={"inventory h-2r d-flex align-items-center justify-content-center"}>
        <div className={groupItem.has_inventory ? "" : "d-none"}>{groupItem.active ? groupItem.qty_on_hand : "0"}</div>
        <div className={groupItem.has_inventory ? "d-none" : ""}>--</div>
    </div>
);
